import { render } from "./Entity.vue?vue&type=template&id=8276fcee&ts=true&lang=pug"
import script from "./Entity.vue?vue&type=script&lang=ts"
export * from "./Entity.vue?vue&type=script&lang=ts"

import "./Entity.vue?vue&type=style&index=0&id=8276fcee&lang=scss"

import exportComponent from "/var/lib/gitlab-runner/builds/Ysdfp3TDT/0/z2a/z-tracker-partners/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__